export function getClientConfig() {
  //@ts-ignore
  if (typeof window !== 'undefined' && window.__client_configs__) {
    //@ts-ignore
    return window.__client_configs__;
  }
  return false;
}
